import React, { useEffect } from "react";

import { connect } from 'react-redux';
import { format } from 'date-fns';

import { Actions as ACTIONS } from 'store/customer/action';
import PageHeading from 'components/PageHeading';

import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { API } from '@aws-amplify/api'

import { customerByBusinessByPhone } from 'graphql/queries'
import { selectDefaultStyle } from 'styles/selectDefaultStyle'

import AsyncSelect from 'react-select/async';
const IndicatorsContainer = () => (
	<div style={{ display: "flex", padding: "6.5px" }}>
		<svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
			<path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
		</svg>
	</div>
)


const Customers = ({ customers, customersNextToken, listCustomers, businessID }) => {
	let history = useHistory();

	useEffect(() => {
		if (!(customers))
			listCustomers(100, customersNextToken);
	}, []);

	return (
		<React.Fragment>
			<PageHeading withCreate={true} />

			<div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
				<div className="flex flex-col">

					<div className="sm:px-12 lg:px-12" style={{ width: "100%" }}>

						<div className="pt-6 grid grid-cols-12 gap-12">
							<div className="col-span-3 col-start-10">
								<AsyncSelect
									className="block form-select w-full p-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
									styles={selectDefaultStyle}
									defaultOptions={[]}
									loadOptions={(inputValue, callback) => {

										console.log('loadOptions', inputValue)

										const beginsWith = inputValue.substr(0, 1) == "+" ?
											inputValue :
											inputValue.substr(0, 2) == "00" ?
												`+${inputValue.substr(2)}` :
												`+356${inputValue}`

										const variables = {
											phone: { beginsWith },
											businessID,
											filter: { active: { ne: false } }
										}
										const request = API.graphql({ query: customerByBusinessByPhone, variables, authMode: "AMAZON_COGNITO_USER_POOLS" })

										request.then(({ data }) => {
											console.log('response', data)

											const customers = data.customerByBusinessByPhone.items.filter(item => item._deleted != true)

											const options = customers && customers.map(customer => ({
												value: customer.id,
												label: `${customer.givenName} ${customer.familyName} (${customer.phone})`
											}))

											callback(options);
										});
									}}
									placeholder="Find client..."
									onChange={(selectedCustomer) => {
										history.push("/customer/" + selectedCustomer.value);
									}}
									components={{ IndicatorsContainer }}
								/>
							</div>
						</div>
					</div>

					<div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
						<div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
							<table className="min-w-full">
								<thead>
									<tr>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Name
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Phone
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Upcoming Booking
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
									</tr>
								</thead>
								<tbody className="bg-white">
									{customers && customers.map((customer, index) => {
										const nextBookingDate = customer.bookings?.items?.find(booking => new Date(booking.date) >= new Date())?.date;

										return (

											<tr key={customer.id}>
												<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
													{customer.givenName} {customer.familyName}
												</td>
												<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
													{customer.phone}
												</td>
												<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
													{nextBookingDate && format(new Date(nextBookingDate), "do MMM yyyy")}
												</td>
												<td className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
													<Link to={`/customer/${customer.id}`} className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline">Edit</Link>
												</td>
											</tr>
										)
									}
									)}
									{customersNextToken &&
										<tr>
											<td onClick={() => listCustomers(100, customersNextToken)}
												className="cursor-pointer px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500 text-center"
												colSpan={7}
											>
												Load More
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


const mapStateToProps = (state) => {
	return {
		businessID: state.businessID,
		customers: state.customer.list,
		customersNextToken: state.customer.listNextToken,
	}
}

const mapDispatchToProps = dispatch => ({
	listCustomers: (limit, nextToken) => dispatch(ACTIONS.getList(limit, nextToken)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Customers)